import { useEffect } from "react";
import { touchActivity, isIdleExpired, IDLE_TIMEOUT_MS } from "./auth";

export function useIdleTimeout(onTimeout) {
  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    let lastTouch = Date.now();
    const onActivity = () => {
      const now = Date.now();
      // Throttle: so escreve 1x por minuto
      if (now - lastTouch > 60_000) {
        touchActivity();
        lastTouch = now;
      }
    };
    events.forEach((e) => window.addEventListener(e, onActivity, { passive: true }));

    const interval = setInterval(() => {
      if (isIdleExpired()) onTimeout();
    }, 30_000);

    return () => {
      events.forEach((e) => window.removeEventListener(e, onActivity));
      clearInterval(interval);
    };
  }, [onTimeout]);
}

export { IDLE_TIMEOUT_MS };
